var render = function () {
  var _vm$images;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [!_vm.multiple ? [(_vm$images = _vm.images) !== null && _vm$images !== void 0 && _vm$images.length ? [_c('company-view-introduction-images-single', _vm._b({}, 'company-view-introduction-images-single', {
    srcs: _vm.srcs
  }, false))] : _vm._e()] : _vm._e(), _vm.multiple ? [_c('company-view-introduction-images-multiple', _vm._b({}, 'company-view-introduction-images-multiple', {
    srcs: _vm.srcs
  }, false))] : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }